import React from 'react';

export default function NoMatch() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Uh oh!</h1>
      <h3>Ugly 404 Page</h3>
    </div>
  );
}
